import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { EnvironmentBannerComponent } from './shared/environment-banner/environment-banner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, EnvironmentBannerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  
  title = 'Vortex Metrics Dashboard';
  currentYear = new Date().getFullYear();
  
  isAuthenticated$!: Observable<boolean>;
  userName: string | null = null;
  hasAdminAccess = false;

  ngOnInit(): void {
    this.isAuthenticated$ = this.authService.isAuthenticated$;
    
    // Subscribe to auth status changes to update user info
    this.isAuthenticated$.subscribe(isAuth => {
      if (isAuth) {
        this.userName = this.authService.getUserName();
        this.hasAdminAccess = this.authService.hasAdminAccess();
      } else {
        this.userName = null;
        this.hasAdminAccess = false;
      }
    });
  }

  login(): void {
    this.authService.login();
  }

  logout(): void {
    this.authService.logout();
  }
}
